import { useEffect, useMemo, useState } from "react";
import BPService from "../../services/resource/bpService";

import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";

export default function CadastroBP({
  onSuccess,
  setShowModal,
  modo = "criar",
  selectedIds = [],
  bpSelecionado = {},
  listaGrupos = [],
  listaCentros = [],
  listaUsuarios = [],
  listaFiliais = [],
  listaContas = []
}) {
  const service = new BPService();

  const [loading, setLoading] = useState(false);

  const [bp, setBp] = useState({
    id: "",
    ano: 2026,
    filiaisIds: [],
    contaContabilCodigo: null,
    grupoId: null,
    centroCustoCodigo: null,
    usuarioId: null,
    codigoDespesa: "",
    usarCodigoDespesa: false,
    filialCodigoDespesa: null,
    centroCustoCodigoDespesa: null,
    contaContabilCodigoDespesa: null
  });

  const opcoesContas = useMemo(
    () =>
      listaContas.map((conta) => ({
        label: `${conta.reduzido} - ${conta.descricao}`,
        value: conta.codigo,
      })),
    [listaContas]
  );

  useEffect(() => {
    if (modo === "editar" && bpSelecionado) {
      setBp({
        id: bpSelecionado.id,
        ano: bpSelecionado.ano,
        contaContabilCodigo: bpSelecionado.contaCodigo || null,
        centroCustoCodigo: bpSelecionado.centroCustoCodigo || null,
        usuarioId: bpSelecionado.responsavelId || null,
        grupoId: Number(bpSelecionado.grupoId) || null,
        codigoDespesa: bpSelecionado.codigoDespesa || "",
        usarCodigoDespesa: bpSelecionado.usarCodigoDespesa || false
      });

    }
  }, [modo, bpSelecionado]);

  useEffect(() => {
    if (
      bp.usarCodigoDespesa &&
      bp.filialCodigoDespesa &&
      bp.centroCustoCodigoDespesa &&
      bp.contaContabilCodigoDespesa
    ) {
      const codigo = `${bp.filialCodigoDespesa}-${bp.centroCustoCodigoDespesa}-${bp.contaContabilCodigoDespesa}`;

      setBp(prev => ({
        ...prev,
        codigoDespesa: codigo
      }));
    }
  }, [
    bp.usarCodigoDespesa,
    bp.filialCodigoDespesa,
    bp.centroCustoCodigoDespesa,
    bp.contaContabilCodigoDespesa
  ]);

  const handleChange = (field, value) => {
    setBp((prev) => ({ ...prev, [field]: value }));
  };

  const salvarBP = () => {
    setLoading(true);

    if (modo === "editar") {
      service
        .atualizarResponsavelEGrupo({
          id: bp.id,
          usuarioId: bp.usuarioId,
          grupoId: bp.grupoId,
          codigoDespesa: bp.codigoDespesa,
          usarCodigoDespesa: bp.usarCodigoDespesa
        })
        .then(() => {
          toast.success("Responsável atualizado com sucesso!");
          onSuccess?.()
          setShowModal(false);
        })
        .catch((error) => {
          console.error("Erro ao atualizar BP:", error);
          console.error("Erro ao atualizar BP.");
        })
        .finally(() => setLoading(false));
    } else if (modo === "criar") {
      service
        .criar(bp)
        .then(() => {
          toast.success("BP cadastrado com sucesso!");
          onSuccess?.()

          setShowModal(false);
        })
        .catch((error) => {
          console.error("Erro ao salvar BP:", error);
        })
        .finally(() => setLoading(false));
    } else if (modo === "editar-em-massa") {
      if (!window.confirm(`Você selecionou ${selectedIds.length} registros. Confirma a alteração de responsável destes registros?`)) return;
      service.atualizarResponsaveis(selectedIds, bp.usuarioId).then(() => {
        toast.success("Atualização realizada com sucesso realizada com sucesso!");
        onSuccess?.()
      })
        .catch(err => console.error("Erro ao atualizar Responsável: " + err));
    }
  };

  return (
    <div className="">
      <div className="p-6 grid grid-cols-1 md:grid-cols-5 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            Ano
          </label>
          <Dropdown
            disabled={modo === "editar"}
            value={bp.ano}
            options={[2025, 2026]}
            onChange={(e) => handleChange("ano", e.value)}
            placeholder="Selecione um usuário"
            className="w-full"
          />
        </div>

        {modo !== "editar-em-massa" &&
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Grupo
            </label>
            <Dropdown
              value={bp.grupoId}
              options={listaGrupos.map((u) => ({
                label: u.descricao,
                value: u.id
              }))}
              filter
              onChange={(e) => handleChange("grupoId", e.value)}
              placeholder="Selecione um grupo"
              className="w-full"
            />
          </div>
        }

        <div>
          <label className="block text-sm font-medium text-foreground mb-1">
            Responsável
          </label>
          <Dropdown
            value={bp.usuarioId}
            options={listaUsuarios.map((u) => ({
              label: u.nome,
              value: u.id
            }))}
            filter
            onChange={(e) => handleChange("usuarioId", e.value)}
            placeholder="Selecione um usuário"
            className="w-full"
          />
        </div>
        {modo !== "editar-em-massa" &&
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Centro de Custo
            </label>
            <Dropdown
              value={bp.centroCustoCodigo}
              options={listaCentros.map((c) => ({
                label: `${c.codigo} - ${c.descricao}`,
                value: c.codigo
              }))}
              filter
              disabled={modo === "editar"}
              onChange={(e) => handleChange("centroCustoCodigo", e.value)}
              placeholder="Selecione o centro"
              className="w-full"
            />
          </div>
        }

        {modo !== "editar-em-massa" &&
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">
              Conta Contábil
            </label>
            <Dropdown
              value={bp.contaContabilCodigo}
              options={opcoesContas}
              filter
              filterBy="label"
              filterInputAutoFocus
              virtualScrollerOptions={{ itemSize: 38 }}
              disabled={modo === "editar"}
              onChange={(e) => handleChange("contaContabilCodigo", e.value)}
              placeholder="Selecione a conta contábil"
              className="w-full"
            />
          </div>
        }

        {modo === "criar" &&
          <div className="md:col-span-5">
            <label className="block text-sm font-medium text-foreground mb-1">
              Filiais
            </label>
            <MultiSelect
              value={bp.filiaisIds}
              options={listaFiliais.map((f) => ({
                label: `${f.codigo} - ${f.nome}`,
                value: f.id
              }))}
              onChange={(e) => handleChange("filiaisIds", e.value)}
              placeholder="Selecione as filiais"
              display="chip"
              className="w-full"
            />
          </div>
        }

        {modo !== "editar-em-massa" &&
          <div className=" md:col-span-5">
            <div className="flex items-center gap-2 mt-2">

              <Checkbox
                inputId="usarCodigoDespesa"
                checked={bp.usarCodigoDespesa}
                onChange={(e) => handleChange("usarCodigoDespesa", e.checked)}
              />
              <label htmlFor="usarCodigoDespesa" className="text-sm text-foreground">
                Usar código de despesa para busca
              </label>
            </div>
            <small className="text-muted-foreground">
              Quando ativado, este BP será localizado pelo código de despesa ao invés do código padrão.
            </small>
          </div>
        }

        {bp.usarCodigoDespesa && (
          <>
            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Filial
              </label>
              <Dropdown
                value={bp.filialCodigoDespesa}
                options={listaFiliais.map(f => ({
                  label: `${f.codigo} - ${f.nome}`,
                  value: f.codigo
                }))}
                filter
                onChange={(e) => handleChange("filialCodigoDespesa", e.value)}
                placeholder="Selecione a filial"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Centro de Custo
              </label>
              <Dropdown
                value={bp.centroCustoCodigoDespesa}
                options={listaCentros.map(c => ({
                  label: `${c.codigo} - ${c.descricao}`,
                  value: c.codigo
                }))}
                filter
                onChange={(e) => handleChange("centroCustoCodigoDespesa", e.value)}
                placeholder="Selecione o centro"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Conta Contábil
              </label>
              <InputText
                type="number"
                value={bp.contaContabilCodigoDespesa}
                onChange={(e) => handleChange("contaContabilCodigoDespesa", e.target.value)}
                placeholder="Informe o código reduzido"
                className="w-full"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-foreground mb-1">
                Código Gerado
              </label>
              <InputText
                value={bp.codigoDespesa}
                disabled
                className="w-full bg-muted"
              />
            </div>
          </>
        )}

      </div>

      <div className="px-6 py-3 border-t border-border bg-muted w-full gap-2 flex justify-end">
        <Button
          type="button"
          label="Cancelar"
          variant="gray"
          iconLeft="fa fa-arrow-left"
          loading={loading}
          onClick={() => setShowModal(false)}
        />
        <Button
          label={"Salvar"}
          iconLeft="fa fa-save"
          variant="indigo"
          loading={loading}
          onClick={salvarBP}
        />
      </div>
    </div>
  );
}
